import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';
import CompanySearchForm from './CompanySearchForm';
import ExistingLegalRegisterForm from './ExistingLegalRegisterForm';

const ExistingLegalRegister = observer(() => {
    const { RegisterStore: store } = useStores();
    const { token, company, clearErrors, clearCompany } = store || {};

    useEffect(() => {
        return () => {
            clearErrors();
            clearCompany();
        };
    }, [clearErrors, clearCompany]);

    return (
        <>
            {token && <Redirect to={{ pathname: '/register/complete' }} />}

            {company ? <ExistingLegalRegisterForm /> : <CompanySearchForm />}
        </>
    );
});

export default ExistingLegalRegister;
